// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type MoneyBackGuarantee40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const MoneyBackGuarantee40Filled: FC<MoneyBackGuarantee40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M17.653 33.333H6.11c-.75 0-1.4-.275-1.951-.826-.551-.551-.827-1.202-.827-1.952V9.445c0-.75.276-1.401.827-1.952.55-.551 1.201-.827 1.951-.827H33.89c.75 0 1.4.276 1.951.827.551.55.827 1.201.827 1.951v9.972h-2.403l-9.347 9.348-5.112-5.084-5.902 5.903 3.75 3.75Zm7.264 3.334-7.084-7.084 1.972-1.972 5.112 5.083 9.805-9.805 1.945 2.027-11.75 11.75ZM6.11 13.332v6.083H33.89v-6.083H6.11Z" />
        </svg>
    );
};

export default MoneyBackGuarantee40Filled;
